import React, { useEffect, useState } from 'react';
import { fetchEmailTemplates } from "../../services/email_template_service";
import { useNavigate } from "react-router-dom";
import { Button, ButtonGroup } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { FaPencilAlt } from "react-icons/fa";


const EmailTemplates = () => {
    const navigate = useNavigate();
    const [emailTemplates, setEmailTemplates] = useState([]);
    const [search, setSearch] = useState("");
    const [filteredTemplates, setFilteredTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const response = await fetchEmailTemplates();
                const fetchedTemplates = response.data;
                setEmailTemplates(fetchedTemplates);
                setFilteredTemplates(fetchedTemplates);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };

        fetchTemplates();
    }, []);

    useEffect(() => {
        const result = emailTemplates.filter((template) =>
            template.name.toLowerCase().includes(search.toLowerCase())
        );
        setFilteredTemplates(result);
    }, [search, emailTemplates]);

    const handleEditTemplate = (templateId) => {
        navigate(`/eTemplates/${templateId}`);
    };

    const columns = [
        {
            name: "ID",
            selector: (row, index) => index + 1,
            sortable: true,
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Type",
            selector: (row) => row.type,
        },
        {
            name: "Actions",
            right: true,
            grow: 2,
            cell: (row) => (
                <ButtonGroup>
                    <Button
                        variant="warning"
                        onClick={() => handleEditTemplate(row.id)}
                    >
                        <span className="me-1"><FaPencilAlt style={{ color: "white" }} /></span>
                        Edit
                    </Button>
                </ButtonGroup>
            ),
        },
    ];

    return (
        <Layout>
            <div className="col-12 stretch-card container-fluid">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h1>Email Templates</h1>
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <DataTable
                                columns={columns}
                                data={filteredTemplates}
                                fixedHeader
                                pagination
                                highlightOnHover
                                subHeader
                                subHeaderComponent={
                                    <input
                                        type="text"
                                        className="w-25 form-control"
                                        placeholder="Search Template"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default EmailTemplates;
